import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-path-up"} maskId="square-filled-radius-0-stroke-1-IconArrowPathUp"><path d="M3.41309 10.9997H8.0002V21.9997H16.0002V10.9997H20.5873L12.0002 0.981445L3.41309 10.9997Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowPathUp;
